export enum E_SmartDisplayGraphLabel {
    Second= 'Second',
    Minute= 'Minute',
    Hour= 'Hour',
    HourExact= 'HourExact',
    FullDateExact= 'FullDateExact',
    FixPercentage= 'FixPercentage',
    Default= 'Default',
    Custom = 'Custom'
}
